export const getFeatureFlags = () => {
  try {
    const envFlags = import.meta.env.VITE_FEATURE_FLAGS ? JSON.parse(import.meta.env.VITE_FEATURE_FLAGS) : {};
    return { ...envFlags };
  } catch (error) {
    console.error('Error parsing feature flags:', error);
    return {};
  }
};
